import { useEffect } from 'react'

import { FormValidationError, track } from '@dfds-frontend/tracking'

import { SelectedDepartures } from '@/states/selection.interface'

import { hasOverlapping } from '../utils'

export const useTrackOverlapping = (selectedDepartures: SelectedDepartures): void => {
  useEffect(() => {
    if (hasOverlapping(selectedDepartures)) {
      track<FormValidationError>({
        errorElementName: 'YourBooking',
        errorMessage: 'Departure overlap',
        errorType: 'validation',
        event: 'formValidationError',
      })
    }
  }, [selectedDepartures])
}
